import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../../../CommonUtils/urlWithParams';
import { useRouteParams } from '../../../hooks/useRouteParams';
import { isAdviserArea as selectIsAdviserArea } from '../../../../../CommonSelectors/CommonAreaSelector';

export const SHARING_SETTINGS_QUERY = 'sharingSettings';

interface RelationshipsDTO {
  AdviserId: number;
  FirstName: string;
  IsManager: boolean;
  IsOwner: boolean;
  IsRemovable: boolean;
  LastName: string;
}

interface SharingSettingsDTO {
  CanTransferOwnership: boolean;
  Relationships: RelationshipsDTO[];
}

const fetchSharingSettings = async (clientId: string): Promise<SharingSettingsDTO> => {
  return authFetch(
    urlWithParams('/Adviser/SharingSettings', {
      clientId,
    }),
  );
};

export const useSharingSettingsQuery = () => {
  const { clientId } = useRouteParams();

  const isAdvisor = useSelector(selectIsAdviserArea);

  return useQuery(
    [SHARING_SETTINGS_QUERY, clientId],

    () => fetchSharingSettings(clientId),

    {
      enabled: isAdvisor,
    },
  );
};
